import { Logo } from "./Logo";

export const Footer = ({ onQuote }) => {
  const cols = [
    { title: "Services", items: ["Full Truckload", "LTL", "Intermodal", "Refrigerated", "Expedited", "Warehousing"] },
    { title: "Company", items: ["Manifesto", "Network", "Portals", "Careers"] },
    { title: "Connect", items: ["Get a Quote", "Become a Carrier", "Contact", "Dispatch 24/7"] },
  ];
  return (
    <footer className="relative z-10 border-t border-white/10 bg-ink" data-testid="footer">
      <div className="mx-auto max-w-[1500px] px-6 py-20 lg:px-12">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <Logo />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-zinc-400">
              A modern USA freight brokerage connecting shippers and carriers across 48 states.
            </p>
            <button
              onClick={onQuote}
              data-testid="footer-quote-btn"
              className="mt-8 bg-neon px-6 py-3 font-mono text-xs font-semibold uppercase tracking-[0.15em] text-black transition-colors duration-300 hover:bg-white"
            >
              Request a Quote
            </button>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-neon">{c.title}</h4>
              <ul className="mt-6 space-y-3">
                {c.items.map((it) => (
                  <li key={it}>
                    <span className="link-underline cursor-pointer text-sm text-zinc-400 hover:text-white">{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-20 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 font-mono text-[11px] uppercase tracking-[0.15em] text-zinc-500 md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} ApexLink Logistics Corp. All rights reserved.</span>
          <span>Moving the world — one link at a time.</span>
        </div>
      </div>
    </footer>
  );
};
